import React from 'react';
import { LeafIcon } from 'lucide-react';
export function BannerBar() {
  const checkoutUrl = 'https://ewordmedia.com/cart/48415277515004:1?checkout';
  return <div className="w-full bg-stone-50 border-b border-stone-200 sticky top-0 z-50 shadow-sm" data-id="element-68">
      <div className="max-w-7xl mx-auto px-4 py-3 flex items-center justify-between gap-4" data-id="element-69">
        <div className="flex items-center gap-2" data-id="element-70">
          <LeafIcon className="w-5 h-5 text-emerald-700 flex-shrink-0" data-id="element-71" />
          <span className="text-stone-900 font-semibold text-sm md:text-base" data-id="element-72">
            Natural Remedy Guide
          </span>
        </div>
        <a href={checkoutUrl} data-cta="sticky-top" onClick={() => {
        if (typeof window !== 'undefined' && (window as any).fbq) {
          ;
          (window as any).fbq('track', 'AddToCart');
        }
      }} className="bg-gradient-to-r from-orange-500 to-orange-600 hover:from-orange-600 hover:to-orange-700 focus:from-orange-600 focus:to-orange-700 focus:outline-none focus:ring-4 focus:ring-orange-300 text-white px-5 md:px-7 py-2.5 rounded-full text-sm md:text-base font-bold transition-all duration-300 shadow-md hover:shadow-lg hover:scale-[1.02] focus:shadow-lg focus:scale-[1.02] transform flex-shrink-0" data-id="element-73">
          <span className="flex items-center gap-1.5" data-id="element-74">
            <span data-id="element-75">Only $17 Today</span>
            <span className="text-lg" data-id="element-76">›</span>
          </span>
        </a>
      </div>
    </div>;
}